import { create } from 'zustand';
import { safeStorage } from '@/shared/lib';
import type { AuthTokens } from '../api/schemas';

/**
 * Сессия админки: access-токен только в памяти, refresh-токен — в safe storage
 * (переживает перезагрузку вкладки; сессия админки — 7 дней с последнего использования, ТЗ 4.3.5).
 */
const REFRESH_TOKEN_KEY = 'session.refresh_token';

interface SessionState {
  accessToken: string | null;
  refreshToken: string | null;
  setTokens: (tokens: AuthTokens) => void;
  clear: () => void;
}

export const useSessionStore = create<SessionState>()((set) => ({
  accessToken: null,
  refreshToken: safeStorage.get(REFRESH_TOKEN_KEY),
  setTokens: (tokens) => {
    safeStorage.set(REFRESH_TOKEN_KEY, tokens.refresh_token);
    set({ accessToken: tokens.access_token, refreshToken: tokens.refresh_token });
  },
  clear: () => {
    safeStorage.remove(REFRESH_TOKEN_KEY);
    set({ accessToken: null, refreshToken: null });
  },
}));

/** Есть ли признаки сессии (токен в памяти или сохранённый refresh-токен). */
export function useHasSession(): boolean {
  return useSessionStore((state) => state.accessToken !== null || state.refreshToken !== null);
}
